import styled from "@emotion/styled";
import { units } from "../../../../types/units";

export const ListItem = styled.div`
  border-bottom: 1px solid #e9e9e9;
  display: block;
  padding: 1rem 2rem;
  cursor: pointer;

  p {
    margin: 0;
  }
  &:focus {
    outline: none;
  }

  ${units({
    backgroundColor: "white",
    "&:hover, &:focus": {
      color: "black",
      backgroundColor: "lightBlue",
    },
  })};
`;

export const ListItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  h3 {
    margin: 0 1rem 0.5rem 0;
  }
`;
